import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { KeyValueBlockModule } from "ngx-zcs-components";
import { MatIconModule } from '@angular/material/icon';

import { HeatpumpDashboardComponent } from './heatpump-dashboard.component';
import { BlockTitleComponent } from '../components/block-title/block-title.component';
import { GenericDeviceDashboardModule } from '../generic-device-dashboard/generic-device-dashboard.module';

@NgModule({
  declarations: [
    HeatpumpDashboardComponent,
  ],
  exports: [
    HeatpumpDashboardComponent,
  ],
  imports: [
    BlockTitleComponent,
    CommonModule,
    GenericDeviceDashboardModule,
    IonicModule,
    KeyValueBlockModule,
    MatIconModule,
  ]
})
export class HeatpumpDashboardModule { }
